export default __webpack_public_path__ + "static/media/grid3.de15fad2.png";